<template>
  <v-card class="elevation-0">
    <v-card-title>
     <h3>How to use this page ?</h3>
    </v-card-title>

    <v-timeline dense>
      <v-timeline-item
        v-for="(item, index) in items"
        :key="index"
        fill-dot
        :icon="item.icon"
        icon-color="white"
      >
        <template v-slot:icon>
        </template>
        <v-card class="elevation-2">
          <v-card-title>
           <h3>{{item.subtitle}}</h3>
          </v-card-title>
          <v-card-text>
            {{item.text}}
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>




  </v-card>
</template>

<script>
  // @vuese
  // Instructions displayed on the routes page.
  // @group Routes
  export default {
    name: "RoutesInstructions",
    data() {
      return {
        items: [
          {
            subtitle :'Step 1',
            text: 'Search for the day and region of which you\'d like to approve the routes',
            icon: 'fas fa-search'
          },
          {
            subtitle :'Step 2',
            text: 'Tick the routes of which you approve the cost. ' +
              'Edit them should you have any change to specify before you tick them.',
            icon: 'far fa-check-square'
          },
          {
            subtitle :'Step 3',
            text: 'Once you made sure every route has been checked/approved, hit the \"Close\" button to send them to us.'
              + ' The ones you approved without modifying will be automatically approved.',
            icon: 'fas fa-check'
          },
          {
            subtitle :'Step 4',
            text: 'Edited rows will go through another level of approval with our team before it gets finally approved.',
            icon: 'fas fa-paper-plane'
          },
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Routes/RoutesInstructions.vue